import { Map, Record as record } from 'immutable';
import t from "../lib/I18n";
import { construct, fields } from "../helpers/LinkMapper";

const defaults = {
    validityPeriod: null,
    dateRange: null,
    originDestination: null,
    adult: null,
    children: null,
    firstClass: null,
};

export default class TicketMetadata extends record(defaults) {
    static fromJSON(json = {}) {
        return construct(TicketMetadata, json, {
            validityPeriod: fields.number,
            dateRange: fields.string,
            originDestination: fields.string,
            adult: fields.string,
            children: fields.string,
            firstClass: fields.string,
        });
    }

    isEmpty () {
        return !this.some((x) => !!x);
    }

    setFromOrderTrip(OrderTrip) {
        const season = OrderTrip.getSeasonFare();
        const adults = season.adults();
        const children = season.children();

       return new Map({
            validityPeriod: season.getOutwardValidityPeriod().days,
            dateRange: ` (${season.getValidFrom().format("DD")} ${season.getValidFrom().format("MMM")} / ${season.getValidTo().format("DD")} ${season.getValidTo().format("MMM")}) `,
            originDestination: ` ${OrderTrip.getFirstOrigin().name} to ${OrderTrip.getDestination().name} `,
            adult: adults ? ` ${t('booking.passengers.adults', {adults})} ` : false,
            children: children ? ` ${t('booking.passengers.children', {children})} ` : false,
            firstClass: season.isFirstClass() && ` - ${t('season.ticket.firstClass')}`,
        });
    }
}



// WEBPACK FOOTER //
// ./src/records/TicketMetadata.js